import { connect } from "react-redux";
import PendingListing from "./PendingList";
import { bindActionCreators } from "redux";
import { userRequestPendingList, userRequestFilter } from "../../../services/redux/userHelpdesk/action";

const mapStateToProps = (state) => ({
    approvalPendingRequest : state.UserHelpdesk.approvalPendingRequest,
    filterDetails : state.UserHelpdesk.filterData,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        userRequestPendingList,
        userRequestFilter
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PendingListing);